import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	cancelIcon: {
		color: colors.red[400]
	},
	finishIcon: {
		color: colors.green[500]
	},
	recodingAnimatedIcon: {
		width: 12,
		height: 12,
		...ColorUtil.getBackgroundAndContrastColor(colors.red[400])
	},
	recordingInfoContainer: {
		flex: 1
	}
})

export default useStyles
